/* eslint-disable complexity */
export const LOADING_MESSAGES = [
    "Checking eligibility",
    "Secure and fast",
    "Usually takes under 10 seconds"
];

export const FORM_CONFIGS = {
    PAGE_1_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Get pre-approval",
            actionKey: "UPDATE"
        },
        alert: null,
        questions: [
            {
                title: null,
                layout: "row",
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "firstName",
                        type: "INPUT",
                        shape: "text",
                        placeholder: "First name",
                        defaultValue: "",
                        isMandatory: true,
                        errorText: "Please enter your first name"
                    },
                    {
                        key: "lastName",
                        type: "INPUT",
                        shape: "text",
                        placeholder: "Last name",
                        defaultValue: "",
                        isMandatory: true,
                        errorText: "Please enter your last name"
                    }
                ]
            },
            {
                key: "dateOfBirth",
                type: "DATE_PICKER",
                title: null,
                placeholder: "Date of Birth (DD/MM/YY)",
                defaultValue: "",
                isMandatory: true,
                errorText: "Please enter your DoB",
                hideInCarFirstFlow: false
            }
        ],
        additionalInfo: {
            usps: [
                { icon: "", text: "No impact on credit score." },
                { icon: "", text: "100% confidentiality & no spams." }
            ]
        }
    },

    PAGE_2_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: null,
        questions: [
            {
                key: "address",
                type: "ADDRESS_INPUT",
                title: null,
                placeholder: "Search for your address",
                defaultValue: "",
                isMandatory: true,
                errorText: "Please enter your address",
                hideInCarFirstFlow: false,
                helperText: "Address used only for verification purposes. Opt for a different delivery location of your car later on, if you wish."
            }
        ],
        additionalInfo: {
            usps: [
                { icon: "", text: "No impact on credit score." },
                { icon: "", text: "100% confidentiality & no spams." }
            ]
        }
    },

    PAGE_3_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "SUBMIT"
        },
        alert: null,
        questions: [
            {
                key: "userEmail",
                type: "INPUT",
                shape: "email",
                title: null,
                placeholder: "Enter email (name@gmail.com)",
                defaultValue: "",
                isMandatory: true,
                errorText: "Please enter an email",
                hideInCarFirstFlow: false,
                helperText: "We'll use your email to send your application summary, important updates, and next steps."
            },
            {
                key: "isTradeIn",
                type: "TOGGLE",
                title: null,
                placeholder: "I have a car to trade in",
                defaultValue: false,
                isMandatory: false,
                hideInCarFirstFlow: true
            },
            {
                key: "isBusiness",
                type: "TOGGLE",
                title: null,
                placeholder: "I am buying for business purposes",
                defaultValue: false,
                isMandatory: false,
                hideInCarFirstFlow: false
            },
            {
                key: "isHomeOwner",
                type: "TOGGLE",
                title: null,
                placeholder: "I am a homeowner",
                defaultValue: false,
                isMandatory: false,
                hideInCarFirstFlow: false
            }
        ],
        additionalInfo: {
            footerText: "You agree that you have read & accepted our Terms and Conditions, Privacy Disclosure Statement, consent to receive marketing material & account creation linked to your email."
        }
    },

    PAGE_4_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: {
            title: "Almost done! Just a few more questions.",
            text: "This helps us get you the accurate results."
        },
        questions: [
            {
                key: "employmentStatus",
                type: "SELECT",
                shape: "single",
                title: "Your employment status",
                placeholder: "",
                defaultValue: "",
                isMandatory: true,
                errorText: "Please select your employment status",
                hideInCarFirstFlow: false,
                options: [
                    { type: "BUTTON", label: "Full time", value: "fullTime" },
                    { type: "BUTTON", label: "Part time", value: "partTime" },
                    { type: "BUTTON", label: "Self employed", value: "selfEmployed" },
                    { type: "BUTTON", label: "Casual", value: "casual" },
                    { type: "BUTTON", label: "Contractor", value: "contractor" },
                    { type: "BUTTON", label: "Unemployed", value: "unemployed" },
                    { type: "BUTTON", label: "Pension", value: "pension" },
                    { type: "BUTTON", label: "Others", value: "others" }
                ]
            },
            {
                key: "visaType",
                type: "SELECT",
                shape: "single",
                title: "Your visa type (if applicable)",
                placeholder: "",
                defaultValue: "",
                isMandatory: true,
                errorText: "Please fill your visa details",
                options: [
                    { type: "BUTTON", label: "Temporary", value: "visa" },
                    { type: "BUTTON", label: "Bridging", value: "bridgingVisa" },
                    { type: "CHECKBOX", label: "I do not have a visa", value: "citizen" }
                ]
            }
        ],
        additionalInfo: {}
    },

    PAGE_4_BUSINESS_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: {
            title: "Almost done! Just a few more questions.",
            text: "This helps us get you the accurate results."
        },
        questions: [
            {
                title: "How long have you been ABN registered?",
                layout: "row",
                isMandatory: true,
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "abnStartMonth",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Month",
                        defaultValue: "",
                        errorText: "Please select starting month",
                        options: [
                            { label: "January", value: "JANUARY" },
                            { label: "February", value: "FEBRUARY" },
                            { label: "March", value: "MARCH" },
                            { label: "April", value: "APRIL" },
                            { label: "May", value: "MAY" },
                            { label: "June", value: "JUNE" },
                            { label: "July", value: "JULY" },
                            { label: "August", value: "AUGUST" },
                            { label: "September", value: "SEPTEMBER" },
                            { label: "October", value: "OCTOBER" },
                            { label: "Novemeber", value: "NOVEMBER" },
                            { label: "December", value: "DECEMBER" }
                        ]
                    },
                    {
                        key: "abnStartYear",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Year",
                        defaultValue: "",
                        errorText: "Please select start year",
                        options: [
                            { label: "2026", value: "2026" },
                            { label: "2025", value: "2025" },
                            { label: "2024", value: "2024" },
                            { label: "2023", value: "2023" },
                            { label: "2022", value: "2022" },
                            { label: "2021", value: "2021" },
                            { label: "2020", value: "2020" },
                            { label: "2019", value: "2019" },
                            { label: "2018", value: "2018" },
                            { label: "2017", value: "2017" },
                            { label: "2016", value: "2016" },
                            { label: "2015", value: "2015" },
                            { label: "2014", value: "2014" },
                            { label: "2013", value: "2013" },
                            { label: "2012", value: "2012" },
                            { label: "2011", value: "2011" },
                            { label: "2010", value: "2010" },
                            { label: "2009", value: "2009" },
                            { label: "2008", value: "2008" },
                            { label: "2007", value: "2007" },
                            { label: "2006", value: "2006" },
                            { label: "2005", value: "2005" },
                            { label: "2004", value: "2004" },
                            { label: "2003", value: "2003" },
                            { label: "2002", value: "2002" },
                            { label: "2001", value: "2001" },
                            { label: "2000", value: "2000" },
                            { label: "1999", value: "1999" },
                            { label: "1998", value: "1998" },
                            { label: "1997", value: "1997" },
                            { label: "1996", value: "1996" },
                            { label: "1995", value: "1995" },
                            { label: "1994", value: "1994" },
                            { label: "1993", value: "1993" },
                            { label: "1992", value: "1992" },
                            { label: "1991", value: "1991" },
                            { label: "1990", value: "1990" },
                            { label: "1989", value: "1989" },
                            { label: "1988", value: "1988" },
                            { label: "1987", value: "1987" },
                            { label: "1986", value: "1986" },
                            { label: "1985", value: "1985" },
                            { label: "1984", value: "1984" },
                            { label: "1983", value: "1983" },
                            { label: "1982", value: "1982" },
                            { label: "1981", value: "1981" },
                            { label: "1980", value: "1980" }
                        ]
                    }
                ]
            },
            {
                title: "When was your business registered for GST?",
                layout: "row",
                isMandatory: true,
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "gstStartMonth",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Month",
                        defaultValue: "",
                        errorText: "Please select starting month",
                        options: [
                            { label: "January", value: "JANUARY" },
                            { label: "February", value: "FEBRUARY" },
                            { label: "March", value: "MARCH" },
                            { label: "April", value: "APRIL" },
                            { label: "May", value: "MAY" },
                            { label: "June", value: "JUNE" },
                            { label: "July", value: "JULY" },
                            { label: "August", value: "AUGUST" },
                            { label: "September", value: "SEPTEMBER" },
                            { label: "October", value: "OCTOBER" },
                            { label: "Novemeber", value: "NOVEMBER" },
                            { label: "December", value: "DECEMBER" }
                        ]
                    },
                    {
                        key: "gstStartYear",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Year",
                        defaultValue: "",
                        errorText: "Please select start year",
                        options: [
                            { label: "2026", value: "2026" },
                            { label: "2025", value: "2025" },
                            { label: "2024", value: "2024" },
                            { label: "2023", value: "2023" },
                            { label: "2022", value: "2022" },
                            { label: "2021", value: "2021" },
                            { label: "2020", value: "2020" },
                            { label: "2019", value: "2019" },
                            { label: "2018", value: "2018" },
                            { label: "2017", value: "2017" },
                            { label: "2016", value: "2016" },
                            { label: "2015", value: "2015" },
                            { label: "2014", value: "2014" },
                            { label: "2013", value: "2013" },
                            { label: "2012", value: "2012" },
                            { label: "2011", value: "2011" },
                            { label: "2010", value: "2010" },
                            { label: "2009", value: "2009" },
                            { label: "2008", value: "2008" },
                            { label: "2007", value: "2007" },
                            { label: "2006", value: "2006" },
                            { label: "2005", value: "2005" },
                            { label: "2004", value: "2004" },
                            { label: "2003", value: "2003" },
                            { label: "2002", value: "2002" },
                            { label: "2001", value: "2001" },
                            { label: "2000", value: "2000" },
                            { label: "1999", value: "1999" },
                            { label: "1998", value: "1998" },
                            { label: "1997", value: "1997" },
                            { label: "1996", value: "1996" },
                            { label: "1995", value: "1995" },
                            { label: "1994", value: "1994" },
                            { label: "1993", value: "1993" },
                            { label: "1992", value: "1992" },
                            { label: "1991", value: "1991" },
                            { label: "1990", value: "1990" },
                            { label: "1989", value: "1989" },
                            { label: "1988", value: "1988" },
                            { label: "1987", value: "1987" },
                            { label: "1986", value: "1986" },
                            { label: "1985", value: "1985" },
                            { label: "1984", value: "1984" },
                            { label: "1983", value: "1983" },
                            { label: "1982", value: "1982" },
                            { label: "1981", value: "1981" },
                            { label: "1980", value: "1980" }
                        ]
                    }
                ]
            },
            {
                key: "isBusinessNotGstRegistered",
                type: "TOGGLE",
                placeholder: "The business is not GST registered",
                defaultValue: false,
                isMandatory: false,
                hideInCarFirstFlow: false
            }
        ],
        additionalInfo: {}
    },

    PAGE_5_TEMPORARY_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: {
            title: "Almost done! Just a few more questions.",
            text: "This helps us get you the accurate results."
        },
        questions: [
            {
                key: "visaClassNumber",
                type: "INPUT",
                shape: "number",
                title: "Visa class number",
                placeholder: "Enter last 3 digits",
                defaultValue: "",
                isMandatory: true,
                errorText: "Please enter visa class number",
                hideInCarFirstFlow: false
            },
            {
                title: "Till when is your visa valid?",
                layout: "row",
                isMandatory: true,
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "visaExpMonth",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Month",
                        defaultValue: "",
                        errorText: "Please select expiry month",
                        options: [
                            { label: "January", value: "JANUARY" },
                            { label: "February", value: "FEBRUARY" },
                            { label: "March", value: "MARCH" },
                            { label: "April", value: "APRIL" },
                            { label: "May", value: "MAY" },
                            { label: "June", value: "JUNE" },
                            { label: "July", value: "JULY" },
                            { label: "August", value: "AUGUST" },
                            { label: "September", value: "SEPTEMBER" },
                            { label: "October", value: "OCTOBER" },
                            { label: "November", value: "NOVEMBER" },
                            { label: "December", value: "DECEMBER" }
                        ]
                    },
                    {
                        key: "visaExpYear",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Year",
                        defaultValue: "",
                        errorText: "Please select expiry year",
                        options: [
                            { label: "2026", value: "2026" },
                            { label: "2027", value: "2027" },
                            { label: "2028", value: "2028" },
                            { label: "2029", value: "2029" },
                            { label: "2030", value: "2030" },
                            { label: "2031", value: "2031" },
                            { label: "2032", value: "2032" },
                            { label: "2033", value: "2033" },
                            { label: "2034", value: "2034" },
                            { label: "2035", value: "2035" }
                        ]
                    }
                ]
            }
        ],
        additionalInfo: {}
    },

    PAGE_5_BRIDGING_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: {
            title: "Almost done! Just a few more questions.",
            text: "This helps us get you the accurate results."
        },
        questions: [
            {
                key: "visaSubclass",
                type: "INPUT",
                shape: "number",
                title: "Visa subclass applied for",
                placeholder: "Enter last 3 digits",
                defaultValue: "",
                isMandatory: true,
                errorText: "Please enter visa subclass",
                hideInCarFirstFlow: false
            }
        ],
        additionalInfo: {}
    },

    PAGE_5_CASUAL_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: {
            title: "Almost done! Just a few more questions.",
            text: "This helps us get you the accurate results."
        },
        questions: [
            {
                title: "When did you start your current job?",
                layout: "row",
                isMandatory: true,
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "empStartMonth",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Month",
                        defaultValue: "",
                        errorText: "Please select starting month",
                        options: [
                            { label: "January", value: "JANUARY" },
                            { label: "February", value: "FEBRUARY" },
                            { label: "March", value: "MARCH" },
                            { label: "April", value: "APRIL" },
                            { label: "May", value: "MAY" },
                            { label: "June", value: "JUNE" },
                            { label: "July", value: "JULY" },
                            { label: "August", value: "AUGUST" },
                            { label: "September", value: "SEPTEMBER" },
                            { label: "October", value: "OCTOBER" },
                            { label: "Novemeber", value: "NOVEMBER" },
                            { label: "December", value: "DECEMBER" }
                        ]
                    },
                    {
                        key: "empStartYear",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Year",
                        defaultValue: "",
                        errorText: "Please select start year",
                        options: [
                            { label: "2026", value: "2026" },
                            { label: "2025", value: "2025" },
                            { label: "2024", value: "2024" },
                            { label: "2023", value: "2023" },
                            { label: "2022", value: "2022" },
                            { label: "2021", value: "2021" },
                            { label: "2020", value: "2020" },
                            { label: "2019", value: "2019" },
                            { label: "2018", value: "2018" },
                            { label: "2017", value: "2017" },
                            { label: "2016", value: "2016" },
                            { label: "2015", value: "2015" },
                            { label: "2014", value: "2014" },
                            { label: "2013", value: "2013" },
                            { label: "2012", value: "2012" },
                            { label: "2011", value: "2011" },
                            { label: "2010", value: "2010" },
                            { label: "2009", value: "2009" },
                            { label: "2008", value: "2008" },
                            { label: "2007", value: "2007" },
                            { label: "2006", value: "2006" },
                            { label: "2005", value: "2005" },
                            { label: "2004", value: "2004" },
                            { label: "2003", value: "2003" },
                            { label: "2002", value: "2002" },
                            { label: "2001", value: "2001" },
                            { label: "2000", value: "2000" },
                            { label: "1999", value: "1999" },
                            { label: "1998", value: "1998" },
                            { label: "1997", value: "1997" },
                            { label: "1996", value: "1996" },
                            { label: "1995", value: "1995" },
                            { label: "1994", value: "1994" },
                            { label: "1993", value: "1993" },
                            { label: "1992", value: "1992" },
                            { label: "1991", value: "1991" },
                            { label: "1990", value: "1990" },
                            { label: "1989", value: "1989" },
                            { label: "1988", value: "1988" },
                            { label: "1987", value: "1987" },
                            { label: "1986", value: "1986" },
                            { label: "1985", value: "1985" },
                            { label: "1984", value: "1984" },
                            { label: "1983", value: "1983" },
                            { label: "1982", value: "1982" },
                            { label: "1981", value: "1981" },
                            { label: "1980", value: "1980" }
                        ]
                    }
                ]
            }
        ],
        additionalInfo: {}
    },

    PAGE_5_CASUAL_TEMP_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: {
            title: "Almost done! Just a few more questions.",
            text: "This helps us get you the accurate results."
        },
        questions: [
            {
                title: "When did you start your current job?",
                layout: "row",
                isMandatory: true,
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "empStartMonth",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Month",
                        defaultValue: "",
                        errorText: "Please select starting month",
                        options: [
                            { label: "January", value: "JANUARY" },
                            { label: "February", value: "FEBRUARY" },
                            { label: "March", value: "MARCH" },
                            { label: "April", value: "APRIL" },
                            { label: "May", value: "MAY" },
                            { label: "June", value: "JUNE" },
                            { label: "July", value: "JULY" },
                            { label: "August", value: "AUGUST" },
                            { label: "September", value: "SEPTEMBER" },
                            { label: "October", value: "OCTOBER" },
                            { label: "Novemeber", value: "NOVEMBER" },
                            { label: "December", value: "DECEMBER" }
                        ]
                    },
                    {
                        key: "empStartYear",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Year",
                        defaultValue: "",
                        errorText: "Please select start year",
                        options: [
                            { label: "2026", value: "2026" },
                            { label: "2025", value: "2025" },
                            { label: "2024", value: "2024" },
                            { label: "2023", value: "2023" },
                            { label: "2022", value: "2022" },
                            { label: "2021", value: "2021" },
                            { label: "2020", value: "2020" },
                            { label: "2019", value: "2019" },
                            { label: "2018", value: "2018" },
                            { label: "2017", value: "2017" },
                            { label: "2016", value: "2016" },
                            { label: "2015", value: "2015" },
                            { label: "2014", value: "2014" },
                            { label: "2013", value: "2013" },
                            { label: "2012", value: "2012" },
                            { label: "2011", value: "2011" },
                            { label: "2010", value: "2010" },
                            { label: "2009", value: "2009" },
                            { label: "2008", value: "2008" },
                            { label: "2007", value: "2007" },
                            { label: "2006", value: "2006" },
                            { label: "2005", value: "2005" },
                            { label: "2004", value: "2004" },
                            { label: "2003", value: "2003" },
                            { label: "2002", value: "2002" },
                            { label: "2001", value: "2001" },
                            { label: "2000", value: "2000" },
                            { label: "1999", value: "1999" },
                            { label: "1998", value: "1998" },
                            { label: "1997", value: "1997" },
                            { label: "1996", value: "1996" },
                            { label: "1995", value: "1995" },
                            { label: "1994", value: "1994" },
                            { label: "1993", value: "1993" },
                            { label: "1992", value: "1992" },
                            { label: "1991", value: "1991" },
                            { label: "1990", value: "1990" },
                            { label: "1989", value: "1989" },
                            { label: "1988", value: "1988" },
                            { label: "1987", value: "1987" },
                            { label: "1986", value: "1986" },
                            { label: "1985", value: "1985" },
                            { label: "1984", value: "1984" },
                            { label: "1983", value: "1983" },
                            { label: "1982", value: "1982" },
                            { label: "1981", value: "1981" },
                            { label: "1980", value: "1980" }
                        ]
                    }
                ]
            },
            {
                visaClassNumber: {
                    key: "visaClassNumber",
                    type: "INPUT",
                    shape: "number",
                    title: "Visa class number",
                    placeholder: "Enter last 3 digits",
                    defaultValue: "",
                    value: "",
                    isMandatory: "true",
                    errorText: "Please enter visa class number",
                    hideInCarFirstFlow: false
                }
            },
            {
                title: "Till when is your visa valid?",
                layout: "row",
                isMandatory: true,
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "visaExpMonth",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Month",
                        defaultValue: "",
                        errorText: "Please select expiry month",
                        options: [
                            { label: "January", value: "JANUARY" },
                            { label: "February", value: "FEBRUARY" },
                            { label: "March", value: "MARCH" },
                            { label: "April", value: "APRIL" },
                            { label: "May", value: "MAY" },
                            { label: "June", value: "JUNE" },
                            { label: "July", value: "JULY" },
                            { label: "August", value: "AUGUST" },
                            { label: "September", value: "SEPTEMBER" },
                            { label: "October", value: "OCTOBER" },
                            { label: "November", value: "NOVEMBER" },
                            { label: "December", value: "DECEMBER" }
                        ]
                    },
                    {
                        key: "visaExpYear",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Year",
                        defaultValue: "",
                        errorText: "Please select expiry year",
                        options: [
                            { label: "2026", value: "2026" },
                            { label: "2027", value: "2027" },
                            { label: "2028", value: "2028" },
                            { label: "2029", value: "2029" },
                            { label: "2030", value: "2030" },
                            { label: "2031", value: "2031" },
                            { label: "2032", value: "2032" },
                            { label: "2033", value: "2033" },
                            { label: "2034", value: "2034" },
                            { label: "2035", value: "2035" }
                        ]
                    }
                ]
            }
        ],
        additionalInfo: {}
    },

    PAGE_5_CASUAL_BRIDGING_FORM: {
        title: "Check loan eligibility in **<1 min**",
        cta: {
            label: "Proceed",
            actionKey: "UPDATE"
        },
        alert: {
            title: "Almost done! Just a few more questions.",
            text: "This helps us get you the accurate results."
        },
        questions: [
            {
                title: "When did you start your current job?",
                layout: "row",
                isMandatory: true,
                hideInCarFirstFlow: false,
                fields: [
                    {
                        key: "empStartMonth",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Month",
                        defaultValue: "",
                        errorText: "Please select starting month",
                        options: [
                            { label: "January", value: "JANUARY" },
                            { label: "February", value: "FEBRUARY" },
                            { label: "March", value: "MARCH" },
                            { label: "April", value: "APRIL" },
                            { label: "May", value: "MAY" },
                            { label: "June", value: "JUNE" },
                            { label: "July", value: "JULY" },
                            { label: "August", value: "AUGUST" },
                            { label: "September", value: "SEPTEMBER" },
                            { label: "October", value: "OCTOBER" },
                            { label: "Novemeber", value: "NOVEMBER" },
                            { label: "December", value: "DECEMBER" }
                        ]
                    },
                    {
                        key: "empStartYear",
                        type: "DROPDOWN",
                        shape: "single",
                        placeholder: "Year",
                        defaultValue: "",
                        errorText: "Please select start year",
                        options: [
                            { label: "2026", value: "2026" },
                            { label: "2025", value: "2025" },
                            { label: "2024", value: "2024" },
                            { label: "2023", value: "2023" },
                            { label: "2022", value: "2022" },
                            { label: "2021", value: "2021" },
                            { label: "2020", value: "2020" },
                            { label: "2019", value: "2019" },
                            { label: "2018", value: "2018" },
                            { label: "2017", value: "2017" },
                            { label: "2016", value: "2016" },
                            { label: "2015", value: "2015" },
                            { label: "2014", value: "2014" },
                            { label: "2013", value: "2013" },
                            { label: "2012", value: "2012" },
                            { label: "2011", value: "2011" },
                            { label: "2010", value: "2010" },
                            { label: "2009", value: "2009" },
                            { label: "2008", value: "2008" },
                            { label: "2007", value: "2007" },
                            { label: "2006", value: "2006" },
                            { label: "2005", value: "2005" },
                            { label: "2004", value: "2004" },
                            { label: "2003", value: "2003" },
                            { label: "2002", value: "2002" },
                            { label: "2001", value: "2001" },
                            { label: "2000", value: "2000" },
                            { label: "1999", value: "1999" },
                            { label: "1998", value: "1998" },
                            { label: "1997", value: "1997" },
                            { label: "1996", value: "1996" },
                            { label: "1995", value: "1995" },
                            { label: "1994", value: "1994" },
                            { label: "1993", value: "1993" },
                            { label: "1992", value: "1992" },
                            { label: "1991", value: "1991" },
                            { label: "1990", value: "1990" },
                            { label: "1989", value: "1989" },
                            { label: "1988", value: "1988" },
                            { label: "1987", value: "1987" },
                            { label: "1986", value: "1986" },
                            { label: "1985", value: "1985" },
                            { label: "1984", value: "1984" },
                            { label: "1983", value: "1983" },
                            { label: "1982", value: "1982" },
                            { label: "1981", value: "1981" },
                            { label: "1980", value: "1980" }
                        ]
                    }
                ]
            },
            {
                visaSubclass: {
                    key: "visaSubclass",
                    type: "INPUT",
                    title: "Visa subclass applied for",
                    placeholder: "Enter last 3 digits",
                    defaultValue: "",
                    isMandatory: "true",
                    errorText: "",
                    hideInCarFirstFlow: false
                }
            }
        ],
        additionalInfo: {}
    },

    PAGE_6_FORM: {
        title: "Final step!",
        cta: {
            label: "Get pre-approval",
            actionKey: "SUBMIT"
        },
        alert: {
            title: "",
            text: "One more question before we show your result"
        },
        questions: [
            {
                key: "annualIncome",
                type: "SELECT",
                shape: "single",
                title: "Your annual gross income",
                subtitle: "This information is confidential & solely used to check your eligibility.",
                isMandatory: true,
                errorText: "Please select your salary range",
                hideInCarFirstFlow: false,
                options: [
                    { type: "BUTTON", label: "$0 - $29,999", value: "LESS_THAN_30K" },
                    { type: "BUTTON", label: "$30,000 - $45,000", value: "30_TO_45K" },
                    { type: "BUTTON", label: "$45,000+", value: "MORE_THAN_45K" }
                ]
            }
        ],
        additionalInfo: {},
        isTerminal: true
    }
};

/**
 * Flow navigation config
 */
export const FLOW_CONFIG = {
    defaultStep: "PAGE_1_FORM",
    inlineSteps: ["PAGE_1_FORM"],
    stepOrder: [
        "PAGE_1_FORM",
        "PAGE_2_FORM",
        "PAGE_3_FORM",
        "PAGE_4_FORM"
    ]
};

// eslint-disable-next-line max-statements, complexity
export const getNextStep = (currentStep, formValues) => {
    const { stepOrder } = FLOW_CONFIG;
    const currentIndex = stepOrder.indexOf(currentStep);
    const { isBusiness, employmentStatus, visaType } = formValues || {};
    const isCasual = employmentStatus === "casual";

    // PAGE_3: Check business flag
    if (currentStep === "PAGE_3_FORM") {
        if (isBusiness === true || isBusiness === "true") {
            return "PAGE_4_BUSINESS_FORM";
        }
        return "PAGE_4_FORM";
    }

    // PAGE_4_BUSINESS: Always go to PAGE_6
    if (currentStep === "PAGE_4_BUSINESS_FORM") {
        return "PAGE_6_FORM";
    }

    // PAGE_4: Route based on employment + visa
    if (currentStep === "PAGE_4_FORM") {
        if (isCasual) {
            if (visaType === "visa") return "PAGE_5_CASUAL_TEMP_FORM";
            if (visaType === "bridgingVisa") return "PAGE_5_CASUAL_BRIDGING_FORM";
            return "PAGE_5_CASUAL_FORM"; // citizen
        } else {
            if (visaType === "visa") return "PAGE_5_TEMPORARY_FORM";
            if (visaType === "bridgingVisa") return "PAGE_5_BRIDGING_FORM";
            return "PAGE_6_FORM"; // citizen - skip PAGE_5
        }
    }

    // All PAGE_5 variants → PAGE_6
    if (currentStep.startsWith("PAGE_5")) {
        return "PAGE_6_FORM";
    }

    // PAGE_6 is the end
    if (currentStep === "PAGE_6_FORM") {
        return null;
    }

    // Default: follow stepOrder
    if (currentIndex < stepOrder.length - 1) {
        return stepOrder[currentIndex + 1];
    }

    return null;
};

export const isInlineStep = (step) => {
    return FLOW_CONFIG.inlineSteps.includes(step);
};

export const isUserDroppedOff = ({ stepsList, answers }) => {
    const hasProgressedBeyondFirstStep = Array.isArray(stepsList) && stepsList.length > 1;
    const hasAnswers = answers && Object.keys(answers).length > 0;
    return hasProgressedBeyondFirstStep && hasAnswers;
};

export const getPageDefaults = (pageConfig) => {
    const defaults = {};
    const questions = pageConfig?.questions || [];
    questions.forEach((question) => {
        if (question.fields) {
            question.fields.forEach((field) => {
                if (field.key && field.defaultValue !== undefined) {
                    defaults[field.key] = field.defaultValue;
                }
            });
        } else if (question.key && question.defaultValue !== undefined) {
            defaults[question.key] = question.defaultValue;
        }
    });
    return defaults;
};

export const EMAIL_STEP = "PAGE_3_FORM";

export const TD_ENTRY_POINTS = ["next-steps-non-pre-approved-modal", "booking-confirmed", "td-confirmation-banner", "test-drive-financing"];

export const ACTION_KEYS = {
    VIEW_ALL_CARS: "VIEW_ALL_CARS",
    COMPLETE_LOAN_APPLICATION: "COMPLETE_LOAN_APPLICATION",
    ANSWER_MORE_QUESTIONS: "ANSWER_MORE_QUESTIONS",
    PROCEED: "PROCEED",
    CONTINUE_BOOKING: "CONTINUE_BOOKING"
};

export const getResultPageConfigForSource = (config, source = "modal") => {
    if (!config) return { cta: null, alert: null, additionalInfo: null, title: null, subtitle: null };
    const cta = config.cta?.[source] !== undefined ? config.cta[source] : config.cta;
    const alert = config.alert?.[source] !== undefined ? config.alert[source] : config.alert;
    const subtitleRaw = config.subtitle?.[source] !== undefined ? config.subtitle[source] : (config.subtitle || null);
    const subtitle = subtitleRaw && typeof subtitleRaw === "object" ? (subtitleRaw.text ?? null) : (subtitleRaw || null);

    let additionalInfo = config.additionalInfo || null;
    if (additionalInfo?.amountLabel && typeof additionalInfo.amountLabel === "object" && additionalInfo.amountLabel[source] !== undefined) {
        additionalInfo = { ...additionalInfo, amountLabel: additionalInfo.amountLabel[source]?.text ?? additionalInfo.amountLabel[source] };
    }

    return { cta, alert, additionalInfo, title: config.title || null, subtitle };
};

export const replaceTemplateVars = (template, vars) => {
    if (!template) return "";
    return template.replace(/\{\{(\w+)\}\}/g, (_, key) => vars[key] ?? "");
};

export default FORM_CONFIGS;
